/** maybe belongs in app.css */


ion-card-header {
  padding-bottom: 0;
}

.pages-col {
  flex-grow: 1;
  overflow-y: none;
  height: 100%;
}

.small-text {
  font-size: 0.8em;
}

.submittal-icon {
  font-size: 1.2em;
  padding: 8px;
}

.right-col {
  flex: 0 0 400px;
  max-width: 400px;
  height: 100%;
}

.right-panel {
  /* make grey like Eduardos new layout */
  border: 1px solid var(--background-color-step-150);
  border-top-left-radius: 1rem;
  background-color: var(--background-color-step-50);
}

#pagesContainer {
  position: relative;
  display: flex;
  flex-direction: column; /* Stack children vertically */
  align-items: center;     /* Centers vertically */
  height: 100%;
  overflow-y: scroll;
  overflow-x: scroll;

  scrollbar-width: thin;
  scrollbar-color: grey transparent;
  scrollbar-gutter: stable;

  background-color:var(--ion-background-color, 'black');
}

#selected-text-button {
  position: absolute;
  width: fit-content;
  z-index: 1000;
}

.page-container {
  position: relative;
  display: inline-block; /* Ensures container wraps around image */
  margin-bottom: 40px;
}

.page-container img {
  position: absolute;
  width: 100%;
  height: 100%;
}

.page-container .svg-holder {
  position: absolute;
  width: 100%;
  height: 100%;
  user-select: text !important;
  -webkit-user-select: text !important;
}

.page-container svg {
  position: absolute;
  width: 100%;
  height: 100%;
}

.page-container .page-num {
  position: absolute;
  right: 0;
  bottom: -20px;
}

.page-container .toggle-edit-button {
  position: absolute;
  top: 100%; /*put the button under the page */
}

.page-container .toggle-close-button {
  position: absolute;
  top: 100%;
}

.edit-form {
  position: absolute;
  padding-left: 40px; /* space for the close button */
  width: 100%;
  top: 100%;
  color: black;
  align-items: center;  /* Align items vertically */
  gap: 10px; /* Space between elements */
  background-color: rgba(255, 255, 255, 0.3);
  border: 1px solid grey;
}

/* Make the buttons transparent so that we can have the background of the container come through */
#divisions-list ion-item::part(native) {
  background-color: transparent !important;
}
/* Make the buttons transparent so that we can have the background of the container come through */
#search-results-list ion-item::part(native) {
  background-color: transparent !important;
}

.menu-section-selected {
  --background: #333;
}

.menu-section-selected .edit-hidden {
  visibility: visible;
}

.section-label {
  width: 100%;
  flex: 1 1 auto; /* allows it to grow */
}

.submittal-link {
  display: block;
  color: var(--ion-text-color, white);
  font-size: 12px;
}

.submittal-link-draft {
  display: block;
  color: lightpink;
  font-size: 12px;
}

.small-bean {
  border-radius: 10px;
  background-color: cadetblue;
  padding: 0 5px;
  color: white;
}

.section-title {
  white-space: nowrap;      /* Prevents wrapping */
  overflow: hidden !important;         /* Hides overflow */
  text-overflow: ellipsis !important;  /* Adds "..." when text is too long */
}

.edit-hidden {
  visibility: hidden;
}

/* We decided to add the thumbnail to the menu for pages with no title */
.menu-thumb {
  display: block;
}

.pages-without-section {
  display: none;
}
